export default __webpack_public_path__ + "static/media/Mature.52fe4932.png";